import reducer from './tracking'

import * as selectors from './selectors'

export { selectors }

export default reducer
